import Swal from 'sweetalert2'

// Configuración personalizada para VVMonE
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

// Configuración de colores corporativos
const SwalVVMonE = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary',
    cancelButton: 'btn btn-secondary'
  },
  buttonsStyling: false,
  confirmButtonColor: '#007BFF',
  cancelButtonColor: '#6c757d',
})

export { Swal, Toast, SwalVVMonE }